<template>
  <div class="pet-store">
    <div class="hero">
      <h1>洛洛崽宠物·省时 省心 省钱</h1>
      <p>下载【洛洛崽宠物】APP，在线购宠、售宠，全国配送！</p>
      <div class="download-buttons">
        <div
          v-for="(link, index) in downloadLinks"
          :key="index"
          class="button-container"
          @mouseover="showQRCode(index)"
          @mouseleave="hideQRCode"
        >
          <!-- <a
            :href="link.url"
            :class="['button', link.class]"
            :aria-label="link.label"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ link.text }}
          </a> -->
          <button :class="['button', link.class]" aria-label="link.label ">
            {{ link.text }}
          </button>

          <img
            v-if="currentQRCode === index"
            :src="link.qrCode"
            :alt="`${link.text} QR Code`"
            class="qr-code"
          />
        </div>
      </div>
    </div>

    <div class="features">
      <div class="feature" v-for="(feature, index) in features" :key="index">
        <img :src="feature.icon" alt="Feature Icon" />
        <h3>{{ feature.title }}</h3>
        <p>{{ feature.description }}</p>
      </div>
    </div>

    <div class="main-content">
      <div class="popular-species">
        <h1>热门品种</h1>
        <div class="species-list">
          <div
            class="species"
            v-for="(species, index) in speciesList"
            :key="index"
          >
            <img :src="species.image" alt="" @click="goToCategories" />
            <div>{{ species.name }}</div>
          </div>
        </div>
      </div>

      <div
        class="product-list"
        v-for="(product, index) in productList"
        :key="index"
      >
        <h2>{{ product.title }}</h2>
        <div class="product">
          <div
            class="item"
            v-for="(item, itemIndex) in product.items"
            :key="itemIndex"
            @click="goToProductDetail(item)"
          >
            <img :src="item.image" alt="Pet Image" class="product-image" />
            <div class="product-info">
              <div class="product-details">
                <span class="product-name" :title="item.name">{{
                  truncatedName(item.name)
                }}</span>
                <span class="product-price">¥{{ item.price }}</span>
              </div>
              <div class="owner-info">
                <img
                  :src="item.owner.avatar"
                  alt="Owner Avatar"
                  class="owner-avatar"
                />
                <span>{{ item.owner.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import storeVer from "@/assets/storeVer.svg";
import camera from "@/assets/camera.svg";
import zijin from "@/assets/zijin.svg";
import baozheng from "@/assets/baozheng.svg";

export default {
  setup() {
    const router = useRouter();

    const goToCategories = () => {
      router.push({ name: "CategoryList" });
    };

    const goToProductDetail = (pet) => {
      router.push({
        name: "ProductDetail",
        params: { id: pet.id },
        query: { pet: JSON.stringify(pet) },
      });
    };

    const speciesList = ref([
      {
        image:
          "https://media.luoluozai.com/llz1/img/1731482790345-3-%E5%B8%83%E5%81%B6%E7%8C%AB.png",
        name: "布偶猫",
      },
      {
        image:
          "http://luoluozai.oss-cn-beijing.aliyuncs.com/1737528829005-Y4-%E8%8B%B1%E5%9B%BD%E7%9F%AD%E6%AF%9B%E7%8C%AB2.png",
        name: "英国短毛猫",
      },
      {
        image:
          "https://media.luoluozai.com/llz1/img/1726295004331-M2-%E7%BE%8E%E5%9B%BD%E7%9F%AD%E6%AF%9B%E7%8C%AB.png",
        name: "美国短毛猫",
      },
      {
        image:
          "https://media.luoluozai.com/llz1/img/1726653382867-5-%E7%BC%85%E5%9B%A0%E7%8C%AB.png",
        name: "缅因猫",
      },
      {
        image:
          "https://media.luoluozai.com/llz1/img/1726732473966-1.3-%E5%B7%A8%E5%9E%8B%E8%B4%B5%E5%AE%BE%E7%8A%AC.png",
        name: "贵宾犬",
      },
      {
        image:
          "https://media.luoluozai.com/llz1/img/1731484653374-2-%E6%AF%94%E7%86%8A.png",
        name: "比熊",
      },
      {
        image:
          "https://media.luoluozai.com/llz1/img/1726707626959-6-%E7%91%9E%E5%85%B8%E6%9F%AF%E5%9F%BA%E7%8A%AC.png",
        name: "柯基",
      },
      {
        image:
          "https://media.luoluozai.com/llz1/img/1726710072851-1-%E8%BE%B9%E5%A2%83%E7%89%A7%E7%BE%8A%E7%8A%AC.png",
        name: "边境牧羊犬",
      },
    ]);

    const features = ref([
      {
        icon: storeVer,
        title: "商家严审",
        description: "商家入驻三大严审措施",
      },
      {
        icon: camera,
        title: "100%实拍",
        description: "四大关卡保障宠物真实性",
      },
      {
        icon: zijin,
        title: "担保交易",
        description: "交易资金平台托管，可追回",
      },
      {
        icon: baozheng,
        title: "137模式",
        description: "137交易模式保障",
      },
    ]);

    const productList = ref([
      {
        title: "狗狗",
        items: [
          {
            id: 1,
            name: "小体型泰迪",
            birthday: "2025-01-25",
            price: 800,
            sex: "母",
            region: "河南省 洛阳市 洛龙区",
            image:
              "https://media.luoluozai.com/llz1/videos/video-covers/20250305104303Qu8mHn_frame_0.jpg",
            video:
              "https://media.luoluozai.com/llz1/videos/20250305104303Qu8mHn.mp4",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/DzGypGzwR2.jpg",
              name: "乐迪宠物",
            },
          },
          {
            id: 2,
            name: "小体比熊弟弟",
            birthday: "2025-01-06",
            price: 7500,
            sex: "公",
            region: "河南省 洛阳市 涧西区",
            image:
              "https://media.luoluozai.com/llz1/videos/video-covers/20250307141809jZBV6y_frame_0.jpg",
            video:
              "https://media.luoluozai.com/llz1/videos/20250307141809jZBV6y.mp4",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/4KnsAsPxZe.jpg",
              name: "萌宠至上",
            },
          },
          {
            id: 3,
            name: "小狗砸",
            birthday: "2023-11-22",
            price: 2500,
            sex: "母",
            region: "河南省 洛阳市 涧西区",
            image:
              "https://luoluozai.oss-cn-beijing.aliyuncs.com/videos/Ea6P5BBQ6B.mp4?x-oss-process=video%2Fsnapshot%2Ct_0%2Cf_jpg%2Cw_720%2Ch_960%2Car_auto",
            video: "https://media.luoluozai.com/llz1/videos/Ea6P5BBQ6B.mp4",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/GhRE2ihPEb.jpg",
              name: "君喵府",
            },
          },
          {
            id: 4,
            name: "咖啡边牧",
            birthday: "2024-10-23",
            price: 1000,
            sex: "母",
            region: "安徽省 宣城市 广德市",
            image:
              "https://media.luoluozai.com/llz1/videos/video-covers/20250306163108emqXBi_frame_0.jpg",
            video:
              "https://media.luoluozai.com/llz1/videos/20250306163108emqXBi.mp4",
            owner: {
              // id: 1,
              avatar:
                "https://media.luoluozai.com/llz1/img/20250305134436ehN65s.jpg",
              name: "喵喵咪呀家养猫咪售卖",
            },
          },
          {
            id: 5,
            name: "自家狗狗生的小金毛，可爱，活泼，健康",
            birthday: "2024-11-13",
            price: 500,
            sex: "母",
            region: "河南省 洛阳市 涧西区",
            image: "https://media.luoluozai.com/llz1/img/YZMBmm4Ptz.jpg",
            video: "https://media.luoluozai.com/llz1/videos/JzbdcxAaWd.mp4",
            owner: {
              // id: 1,
              avatar:
                "https://media.luoluozai.com/llz1/img/202503051321068jdwML.jpg",
              name: "阿强酷猫坊",
            },
          },
          {
            id: 6,
            name: "比熊幼犬对外出售",
            birthday: "2024-12-01",
            price: 900,
            sex: "公",
            region: "安徽省 宣城市 广德市",
            image:
              "https://luoluozai.oss-cn-beijing.aliyuncs.com/videos/dY5Syp8Q7R.mp4?x-oss-process=video%2Fsnapshot%2Ct_0%2Cf_jpg%2Cw_1080%2Ch_1920%2Car_auto",
            video: "https://media.luoluozai.com/llz1/videos/dY5Syp8Q7R.mp4",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
              name: "喵喵咪呀家养猫咪售卖",
            },
          },
          {
            id: 7,
            name: "人见人爱的萨摩耶",
            birthday: "2023-08-01",
            price: 1500,
            sex: "公",
            region: "河南省 洛阳市 涧西区",
            image:
              "https://luoluozai.oss-cn-beijing.aliyuncs.com/videos/4PAsKrANxJ.mp4?x-oss-process=video%2Fsnapshot%2Ct_0%2Cf_jpg%2Cw_720%2Ch_1280%2Car_auto",
            video: "https://media.luoluozai.com/llz1/videos/4PAsKrANxJ.mp4",
            owner: {
              // id: 1,
              avatar:
                "https://media.luoluozai.com/llz1/img/202503051321068jdwML.jpg",
              name: "阿强酷猫坊",
            },
          },
          {
            id: 8,
            name: "小体博美母",
            birthday: "2024-09-10",
            price: 1500,
            sex: "母",
            region: "安徽省 宣城市 广德市",
            image:
              "https://luoluozai.oss-cn-beijing.aliyuncs.com/videos/3emtwR6W5m.mp4?x-oss-process=video%2Fsnapshot%2Ct_0%2Cf_jpg%2Cw_1080%2Ch_1920%2Car_auto",
            video: "https://media.luoluozai.com/llz1/videos/3emtwR6W5m.mp4",
            owner: {
              // id: 1,
              avatar:
                "https://media.luoluozai.com/llz1/img/20250305134436ehN65s.jpg",
              name: "喵喵咪呀家养猫咪售卖",
            },
          },
          {
            id: 9,
            name: "双血统金毛弟弟",
            birthday: "2025-01-01",
            price: 3500,
            sex: "公",
            region: "辽宁省 沈阳市 沈北新区",
            image:
              "https://luoluozai.oss-cn-beijing.aliyuncs.com/videos/rT832Zami5.mp4?x-oss-process=video%2Fsnapshot%2Ct_0%2Cf_jpg%2Cw_720%2Ch_1556%2Car_auto",
            video: "https://media.luoluozai.com/llz1/videos/rT832Zami5.mp4",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
              name: "不爱大脑福",
            },
          },
          {
            id: 10,
            name: "20年老店自己繁殖一窝小体韩版健康比熊",
            birthday: "2024-11-05",
            price: 12000,
            sex: "公",
            region: "辽宁省 沈阳市 沈北新区",
            image:
              "https://luoluozai.oss-cn-beijing.aliyuncs.com/videos/pcN2WeMrRH.mp4?x-oss-process=video%2Fsnapshot%2Ct_0%2Cf_jpg%2Cw_1080%2Ch_1920%2Car_auto",
            video: "https://media.luoluozai.com/llz1/videos/pcN2WeMrRH.mp4",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
              name: "不爱大脑福",
            },
          },
          {
            id: 11,
            name: "超小体韩系泰迪弟弟",
            birthday: "2024-10-25",
            price: 6800,
            sex: "公",
            region: "辽宁省 沈阳市 沈北新区",
            image:
              "https://luoluozai.oss-cn-beijing.aliyuncs.com/videos/8HtGmQxSSr.mp4?x-oss-process=video%2Fsnapshot%2Ct_0%2Cf_jpg%2Cw_720%2Ch_1280%2Car_auto",
            video: "https://media.luoluozai.com/llz1/videos/8HtGmQxSSr.mp4",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
              name: "不爱大脑福",
            },
          },
        ],
      },
      {
        title: "猫猫",
        items: [
          {
            id: 1,
            name: "英国短毛猫",
            birthday: "2023-08-01",
            price: 1000,
            sex: "母",
            region: "辽宁省 沈阳市 沈北新区",
            image:
              "https://media.luoluozai.com/llz1/videos/video-covers/20250223143254pPlek2_frame_0.jpg",
            video:
              "https://media.luoluozai.com/llz1/video/1726295004331-M2-%E7%BE%8E%E5%9B%BD%E7%9F%AD%E6%AF%9B%E7%8C%AB.mp4",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
              name: "金渐层稀有色繁育",
            },
          },
          {
            id: 2,
            name: "紫金长毛种公",
            birthday: "2025-01-06",
            price: 7500,
            sex: "公",
            region: "河南省 洛阳市 涧西区",
            image:
              "https://media.luoluozai.com/llz1/videos/video-covers/20250306161440fvj4PW_frame_0.jpg",
            video:
              "https://media.luoluozai.com/llz1/videos/20250306161440fvj4PW.mp4",
            owner: {
              // id: 1,
              avatar:
                "https://media.luoluozai.com/llz1/img/202503051321068jdwML.jpg",
              name: "阿强酷猫坊",
            },
          },
          {
            id: 3,
            name: "缅因猫",
            birthday: "2023-09-10",
            price: 5500,
            sex: "母",
            region: "河南省 洛阳市 涧西区",
            image:
              "https://media.luoluozai.com/llz1/img/20250227140130EiePw5.jpg",
            video:
              "https://media.luoluozai.com/llz1/videos/20250227140123Ksnnme.mp4",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/GhRE2ihPEb.jpg",
              name: "君喵府",
            },
          },
          {
            id: 4,
            name: "矮脚妹妹",
            birthday: "2024-10-23",
            price: 1000,
            sex: "母",
            region: "安徽省 宣城市 广德市",
            image:
              "https://media.luoluozai.com/llz1/videos/video-covers/20250306163108emqXBi_frame_0.jpg",
            video:
              "https://media.luoluozai.com/llz1/videos/20250306163108emqXBi.mp4",
            owner: {
              // id: 1,
              avatar:
                "https://media.luoluozai.com/llz1/img/20250305134436ehN65s.jpg",
              name: "喵喵咪呀家养猫咪售卖",
            },
          },
          {
            id: 5,
            name: "紫金妹妹",
            birthday: "2023-08-01",
            price: 1000,
            sex: "母",
            region: "河南省 洛阳市 涧西区",
            image:
              "https://media.luoluozai.com/llz1/videos/video-covers/20250306161828WUN1SK_frame_0.jpg",
            video:
              "https://media.luoluozai.com/llz1/video/1726295004331-M2-%E7%BE%8E%E5%9B%BD%E7%9F%AD%E6%AF%9B%E7%8C%AB.mp4",
            owner: {
              // id: 1,
              avatar:
                "https://media.luoluozai.com/llz1/img/202503051321068jdwML.jpg",
              name: "阿强酷猫坊",
            },
          },
          {
            id: 6,
            name: "长毛弟弟",
            birthday: "2024-09-19",
            price: 1000,
            sex: "公",
            region: "安徽省 宣城市 广德市",
            image:
              "https://media.luoluozai.com/llz1/videos/video-covers/2025030616270985Z4nE_frame_0.jpg",
            video:
              "https://media.luoluozai.com/llz1/videos/2025030616270985Z4nE.mp4",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
              name: "喵喵咪呀家养猫咪售卖",
            },
          },
          {
            id: 7,
            name: "金渐层宝宝",
            birthday: "2023-08-01",
            price: 5600,
            sex: "母",
            region: "河南省 洛阳市 涧西区",
            image:
              "https://media.luoluozai.com/llz1/videos/video-covers/20250305194908j4USPK_frame_0.jpg",
            video:
              "https://media.luoluozai.com/llz1/videos/20250305194908j4USPK.mp4",
            owner: {
              // id: 1,
              avatar:
                "https://media.luoluozai.com/llz1/img/202503051321068jdwML.jpg",
              name: "阿强酷猫坊",
            },
          },
          {
            id: 8,
            name: "长毛金虎斑妹妹",
            birthday: "2025-01-26",
            price: 1000,
            sex: "母",
            region: "安徽省 宣城市 广德市",
            image:
              "https://media.luoluozai.com/llz1/videos/video-covers/202503051455165fT5Ub_frame_0.jpg",
            video:
              "https://media.luoluozai.com/llz1/videos/202503051455165fT5Ub.mp4",
            owner: {
              // id: 1,
              avatar:
                "https://media.luoluozai.com/llz1/img/20250305134436ehN65s.jpg",
              name: "喵喵咪呀家养猫咪售卖",
            },
          },
          {
            id: 9,
            name: "两只紫金弟弟",
            birthday: "2025-01-01",
            price: 7500,
            sex: "公",
            region: "辽宁省 沈阳市 沈北新区",
            image:
              "https://media.luoluozai.com/llz1/videos/video-covers/20250223143254pPlek2_frame_0.jpg",
            video:
              "https://media.luoluozai.com/llz1/videos/20250223143254pPlek2.mp4",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
              name: "金渐层稀有色繁育",
            },
          },
        ],
      },
      {
        title: "小宠",
        items: [
          {
            id: 1,
            name: "暴风雪一百多克",
            birthday: "2024-08-01",
            price: 1000,
            sex: "母",
            region: "河南省 洛阳市 涧西区",
            image:
              "https://media.luoluozai.com/llz1/img/20250227135857pUORfd.jpg",
            video: "",
            owner: {
              // id: 1,
              avatar: "https://media.luoluozai.com/llz1/img/GhRE2ihPEb.jpg",
              name: "君喵府",
            },
          },
          // {
          //   id: 2,
          //   name: "紫金长毛种公",
          //   birthday: "2025-01-06",
          //   price: 7500,
          //   sex: "公",
          //   region: "河南省 洛阳市 涧西区",
          //   image:
          //     "https://media.luoluozai.com/llz1/videos/video-covers/20250306161440fvj4PW_frame_0.jpg",
          //   video:
          //     "https://media.luoluozai.com/llz1/videos/20250306161440fvj4PW.mp4",
          //   owner: {
          //     // id: 1,
          //     avatar:
          //       "https://media.luoluozai.com/llz1/img/202503051321068jdwML.jpg",
          //     name: "阿强酷猫坊",
          //   },
          // },
          // {
          //   id: 3,
          //   name: "缅因猫",
          //   birthday: "2023-09-10",
          //   price: 5500,
          //   sex: "母",
          //   region: "河南省 洛阳市 涧西区",
          //   image:
          //     "https://media.luoluozai.com/llz1/img/20250227140130EiePw5.jpg",
          //   video:
          //     "https://media.luoluozai.com/llz1/videos/20250227140123Ksnnme.mp4",
          //   owner: {
          //     // id: 1,
          //     avatar: "https://media.luoluozai.com/llz1/img/GhRE2ihPEb.jpg",
          //     name: "君喵府",
          //   },
          // },
          // {
          //   id: 4,
          //   name: "矮脚妹妹",
          //   birthday: "2024-10-23",
          //   price: 1000,
          //   sex: "母",
          //   region: "安徽省 宣城市 广德市",
          //   image:
          //     "https://media.luoluozai.com/llz1/videos/video-covers/20250306163108emqXBi_frame_0.jpg",
          //   video:
          //     "https://media.luoluozai.com/llz1/videos/20250306163108emqXBi.mp4",
          //   owner: {
          //     // id: 1,
          //     avatar:
          //       "https://media.luoluozai.com/llz1/img/20250305134436ehN65s.jpg",
          //     name: "喵喵咪呀家养猫咪售卖",
          //   },
          // },
          // {
          //   id: 5,
          //   name: "紫金妹妹",
          //   birthday: "2023-08-01",
          //   price: 1000,
          //   sex: "母",
          //   region: "河南省 洛阳市 涧西区",
          //   image:
          //     "https://media.luoluozai.com/llz1/videos/video-covers/20250306161828WUN1SK_frame_0.jpg",
          //   video:
          //     "https://media.luoluozai.com/llz1/video/1726295004331-M2-%E7%BE%8E%E5%9B%BD%E7%9F%AD%E6%AF%9B%E7%8C%AB.mp4",
          //   owner: {
          //     // id: 1,
          //     avatar:
          //       "https://media.luoluozai.com/llz1/img/202503051321068jdwML.jpg",
          //     name: "阿强酷猫坊",
          //   },
          // },
          // {
          //   id: 6,
          //   name: "长毛弟弟",
          //   birthday: "2024-09-19",
          //   price: 1000,
          //   sex: "公",
          //   region: "安徽省 宣城市 广德市",
          //   image:
          //     "https://media.luoluozai.com/llz1/videos/video-covers/2025030616270985Z4nE_frame_0.jpg",
          //   video:
          //     "https://media.luoluozai.com/llz1/videos/2025030616270985Z4nE.mp4",
          //   owner: {
          //     // id: 1,
          //     avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
          //     name: "喵喵咪呀家养猫咪售卖",
          //   },
          // },
          // {
          //   id: 7,
          //   name: "金渐层宝宝",
          //   birthday: "2023-08-01",
          //   price: 5600,
          //   sex: "母",
          //   region: "河南省 洛阳市 涧西区",
          //   image:
          //     "https://media.luoluozai.com/llz1/videos/video-covers/20250305194908j4USPK_frame_0.jpg",
          //   video:
          //     "https://media.luoluozai.com/llz1/videos/20250305194908j4USPK.mp4",
          //   owner: {
          //     // id: 1,
          //     avatar:
          //       "https://media.luoluozai.com/llz1/img/202503051321068jdwML.jpg",
          //     name: "阿强酷猫坊",
          //   },
          // },
          // {
          //   id: 8,
          //   name: "长毛金虎斑妹妹",
          //   birthday: "2025-01-26",
          //   price: 1000,
          //   sex: "母",
          //   region: "安徽省 宣城市 广德市",
          //   image:
          //     "https://media.luoluozai.com/llz1/videos/video-covers/202503051455165fT5Ub_frame_0.jpg",
          //   video:
          //     "https://media.luoluozai.com/llz1/videos/202503051455165fT5Ub.mp4",
          //   owner: {
          //     // id: 1,
          //     avatar:
          //       "https://media.luoluozai.com/llz1/img/20250305134436ehN65s.jpg",
          //     name: "喵喵咪呀家养猫咪售卖",
          //   },
          // },
          // {
          //   id: 9,
          //   name: "两只紫金弟弟",
          //   birthday: "2025-01-01",
          //   price: 7500,
          //   sex: "公",
          //   region: "辽宁省 沈阳市 沈北新区",
          //   image:
          //     "https://media.luoluozai.com/llz1/videos/video-covers/20250223143254pPlek2_frame_0.jpg",
          //   video:
          //     "https://media.luoluozai.com/llz1/videos/20250223143254pPlek2.mp4",
          //   owner: {
          //     // id: 1,
          //     avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
          //     name: "金渐层稀有色繁育",
          //   },
          // },
        ],
      },
    ]);
    const currentQRCode = ref(null);

    const downloadLinks = ref([
      {
        text: "苹果下载",
        url: "#",
        class: "apple",
        label: "前往 App Store 下载",
        qrCode:
          "https://luoluozai.obs.cn-east-3.myhuaweicloud.com/llz1/app/static/OfficialAccounts.png",
      },
      {
        text: "安卓下载",
        url: "#",
        class: "android",
        label: "前往 Google Play 下载",
        qrCode:
          "https://luoluozai.obs.cn-east-3.myhuaweicloud.com/llz1/app/static/OfficialAccounts.png",
      },
      {
        text: "微信小程序",
        url: "#",
        class: "wechat",
        label: "打开微信小程序",
        qrCode:
          "https://luoluozai.obs.cn-east-3.myhuaweicloud.com/llz1/app/static/OfficialAccounts.png",
      },
    ]);

    const showQRCode = (index) => {
      currentQRCode.value = index;
    };

    const hideQRCode = () => {
      currentQRCode.value = null;
    };

    const truncatedName = (name, length = 12) => {
      if (name.length > length) {
        return name.substring(0, length) + "...";
      }
      return name;
    };

    return {
      speciesList,
      productList,
      features,
      downloadLinks,
      currentQRCode,
      showQRCode,
      hideQRCode,
      goToCategories,
      goToProductDetail,
      truncatedName,
    };
  },
};
</script>

<style scoped>
<style scoped>
/* Hero 样式 */
.hero {
  background-color: #fff;
  padding: 40px 20px;
  text-align: center;
  width: 60%;
  max-width: 1200px;
  margin: 0 auto;
}

.hero h1 {
  font-size: 32px;
  margin-bottom: 10px;
}

.hero p {
  font-size: 16px;
  color: #666;
}

.download-buttons {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.button-container {
  position: relative;
  margin: 5px 20px; /* 增加按钮之间的间隔 */
}

.button {
  margin: 5px;
  padding: 10px 20px;
  background-color: #ff9900;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px; /* 设置固定宽度 */
}

.qr-code {
  position: absolute;
  top: -160px; /* 调整二维码图片的位置 */
  left: 50%;
  transform: translateX(-50%);
  width: 150px; /* 设置与按钮相同的宽度 */
  height: 150px; /* 设置与按钮相同的高度 */
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 特点功能样式 */
.features {
  display: flex;
  justify-content: space-around;
  width: 60%;
  max-width: 1200px;
  margin: 20px auto;
}

.feature {
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  flex: 1; /* 确保每个 feature 占据相同的宽度 */
  margin: 0 10px; /* 添加左右间距 */
}

/* 主要内容样式 */
.main-content {
  width: 60%;
  max-width: 1200px;
  padding: 20px;
  margin: 0 auto;
}

.popular-species {
  margin-bottom: 20px;
}

.species-list {
  display: flex;
  justify-content: space-around;
}

.species img {
  width: 50px; /* 根据需要调整 */
  height: 50px;
  border-radius: 50%;
}

.product-list {
  margin-bottom: 20px;
}

.product {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.item {
  width: calc(25% - 10px); /* 每行4条，每条占25%，减去间距 */
  margin-bottom: 10px;
  margin-right: 10px;
  box-sizing: border-box;
  cursor: pointer; /* 添加鼠标悬停效果 */
}

/* 处理不足4条数据的情况 */
.product .item:nth-child(4n + 1) {
  margin-left: 0; /* 第一个元素不加左边距 */
}

.product .item:nth-child(4n) {
  margin-right: 0; /* 第四个元素不加右边距 */
}

.product-image {
  width: 100%; /* 使图片宽度占满父容器 */
  aspect-ratio: 1 / 1; /* 确保图片按比例展示为正方形 */
  object-fit: cover; /* 确保图像按比例缩放并裁剪以适应容器 */
  border-radius: 5px;
}

.product-info {
  margin-top: 10px;
}

.product-details {
  display: flex;
  justify-content: space-between; /* 分左右两边展示 */
  margin-bottom: 10px; /* 添加间隔 */
}

.product-name {
  margin-left: 10px;
  display: block;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出的文本 */
  text-overflow: ellipsis; /* 显示省略号 */
}

.product-price {
  margin-right: 10px;
  display: block;
}

.owner-info {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* 左对齐 */
  margin-top: 10px;
  margin-left: 10px;
}

.owner-avatar {
  width: 20px; /* 小图标大小 */
  height: 20px;
  border-radius: 50%;
  margin-right: 5px; /* 添加间隔 */
}
</style>
